import { createSlice } from '@reduxjs/toolkit'
import { KycDetailsPartial, KycJourneyStatus, MerchantSignatory } from 'models'

interface KycState {
  partialKycDetails: KycDetailsPartial
  journeyStatus: KycJourneyStatus | null
  signatory: MerchantSignatory | null
  isContactEditable: boolean
}

const initialState: KycState = {
  partialKycDetails: {} as KycDetailsPartial,
  journeyStatus: null,
  signatory: null,
  isContactEditable: false, // TODO: Move this to merchant slice when it's ready.
}

const kycSlice = createSlice({
  name: 'kyc',
  initialState: initialState,
  reducers: {
    setPartialKycDetails: (state, { payload }) => {
      if (payload) {
        state.partialKycDetails = {
          ...state.partialKycDetails,
          ...payload,
        }
      }
    },
    setKycJourneyStatus: (state, { payload }) => {
      if (payload) {
        state.journeyStatus = payload
      }
    },
    setSignatory: (state, { payload }) => {
      state.signatory = payload
    },
    setIsContactEditable: (state, { payload }) => {
      state.isContactEditable = payload
    },
    clearPartialKycDetails: (state) => {
      state.partialKycDetails = {} as KycDetailsPartial
    },
  },
})

export const {
  setPartialKycDetails,
  setKycJourneyStatus,
  setIsContactEditable,
  setSignatory,
  clearPartialKycDetails,
} = kycSlice.actions

export const kyc = (state) => state.kyc

export default kycSlice.reducer
